export {default as KlarnaFooter} from './KlarnaFooter'



// WEBPACK FOOTER //
// ./src/components/klarnaFooter/index.js